import {Icon} from '@wandb/weave/components/Icon';
import {Browse3} from '@wandb/weave/components/PagePanelComponents/Home/Browse3';
import React, {useCallback, useMemo} from 'react';
import {Link, useHistory, useLocation} from 'react-router-dom';

import {WEAVE_OBJECT_SUBMENU} from '../pages/ProjectPage/useProjectSidebar';
import {WEAVE_SLUG} from '../routes/paths';
import {apolloEndpoint} from '../util/apollo';
import {useBetaFeatureWeave1} from '../util/useBetaFeature';
import {BannerBoldText, BannerFlexWrapper, BannerTextWrapper} from './Banner';
import {WeaveIntercomChatButton} from './IntercomChatButton';

type ProjectWeaveTabProps = {
  entityName: string;
  projectName: string;
};

const FANCY_PAGE_SECONDARY_HEADER_HEIGHT = 57;

export const ProjectWeaveTab = (props: ProjectWeaveTabProps) => {
  const weave1Enabled = useBetaFeatureWeave1();
  const history = useHistory();
  const projectOverviewPath = `/${props.entityName}/${props.projectName}/overview`;
  const navigateAwayFromProject = useCallback(() => {
    history.push(projectOverviewPath);
  }, [history, projectOverviewPath]);

  // Derive assets submenu slugs from the single source of truth
  const assetsSubmenuSlugs = useMemo(() => {
    const slugs: string[] = [];
    WEAVE_OBJECT_SUBMENU.forEach(item => {
      slugs.push(item.slug);
      if (item.additionalSlugs) {
        slugs.push(...item.additionalSlugs);
      }
    });
    return slugs;
  }, []);

  // Detect if we're on a page that shows the FancyPage secondary header
  const location = useLocation();
  const currentPath = location.pathname;
  const hasSecondaryHeader = assetsSubmenuSlugs.some(slug =>
    currentPath.includes(slug)
  );

  // Base header offset (60) + secondary header height if present
  const headerOffset =
    60 + (hasSecondaryHeader ? FANCY_PAGE_SECONDARY_HEADER_HEIGHT : 0);

  if (!weave1Enabled) {
    return (
      <div
        className={WEAVE_SLUG}
        style={{
          height: '100%',
          width: '100%',
          overflow: 'hidden',
          backgroundColor: 'white',
        }}>
        <div style={{padding: '20px'}}>
          <BannerFlexWrapper>
            <Icon name="lightbulb-info" />
            <BannerTextWrapper>
              <BannerBoldText>Weave</BannerBoldText>allows you to track,
              analyze, and compare ML functions such as LLM invocations,
              document retrievals, and model predictions. Weave needs weave1
              enabled to work.{' '}
              <Link to={'/settings#betafeatures'}>Click here</Link> to go to
              your user settings.
            </BannerTextWrapper>
          </BannerFlexWrapper>
        </div>
      </div>
    );
  }

  return (
    <div
      className={WEAVE_SLUG}
      style={{
        height: '100%',
        width: '100%',
        overflow: 'hidden',
        backgroundColor: 'white',
      }}>
      <Browse3
        hideHeader
        headerOffset={headerOffset}
        projectRoot={(entityName: string, projectName: string) => {
          return `/${entityName}/${projectName}/${WEAVE_SLUG}`;
        }}
        navigateAwayFromProject={navigateAwayFromProject}
        gorillaApolloEndpoint={apolloEndpoint}
      />
      <WeaveIntercomChatButton />
    </div>
  );
};
